/*! Wave Colour Studio, (c) afzuigkapSpecialist.nl. Alle rechten voorbehouden. Kopieren, hergebruiken of doorverkopen zonder schriftelijke toestemming is niet toegestaan. */
/* Kleurvoorbeeld in de configurator.
   4 okt (studio2): nieuwe maskermotor (wave-color-engine.js, W.mask) voor alle modellen met een pdf-tekening: kleur exact binnen de lijnen,
   kleur 1/2 volgens de voorbeelden in de pdf, materialen (geborsteld RVS, mat, glanzend, metallic, leder), licht (2700 K) met aan/uit, dimmer en avondmodus,
   en de knop 'Bekijk in jouw keuken' (wave-color-kitchen.js, wordt pas geladen als je erop klikt). Valt terug op de oude motor (W.eng) als iets ontbreekt. */
(function () {
var W = window.WVS, REAL = W.REAL, NAMES = W.NAMES, CHIPS = W.CHIPS, norm = W.norm, rgb = W.rgb, parse = W.parse, esc = W.esc, eng = W.eng;
var finErr = null, finRow = null;
var handle = (location.pathname.split('/products/')[1] || '').split('/')[0];
var shellMode = W.MODES.some(function (r) { return r.test(handle); });
var lampType = W.lamp ? W.lamp.type(handle) : '';
var plafond = /plafondunit|plafond-unit|inbouwunit|inbouw-unit/.test(handle);
var state = { finish: '', imgFailed: false, mode: shellMode ? 'shell' : (plafond ? 'flat' : 'under'), src: '', urls: 0, scores: [], drawing: null, error: '', engine: '', light: 1, night: false };
W.state = state;
window.addEventListener('submit', function (e) {
var f = e.target; if (!f || !f.matches || !f.matches('form.js-product-form-main')) return;
var box = document.querySelector('[data-wvc-custom]'); if (!box || box.hidden) return;
if (!state.finish) {
e.preventDefault(); e.stopImmediatePropagation();
if (finErr) finErr.hidden = false;
if (finRow) finRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
return;
}
box.querySelectorAll(`input[type=text][name^='wvc-custom-']`).forEach(function (i) {
var v = i.value.replace(/ *[(](mat|glanzend)[)] *$/i, '').trim();
if (v) i.value = v + ' (' + state.finish.toLowerCase() + ')';
});
}, true);
/* Sleutel van de tekening: eerste 4 cijfers in de handle (Sphere = 2176); 90/120 cm waar nodig; 2605 lamp apart. */
function drawKey() {
var h = handle, m = h.match(/(?:^|[^0-9])([0-9]{4})/), k = /sphere/.test(h) ? '2176' : (m ? m[1] : '');
var rest = h.replace(k, '');
if (/^(2119|2120|1119|1120)$/.test(k)) k += /(^|-)(120|110|100)-?cm/.test(rest) ? '-120' : '-90';
else if (/^(3663|8663|8231|8674)$/.test(k)) k += /(^|-)120(-|x|cm)/.test(rest) ? '-120' : '-90';
else if (k === '2605' && /(^|-)lamp(-|$)/.test(rest) && !/afzuiglamp/.test(rest)) k = '2605-lamp';
return k;
}
var dKey = drawKey();
function init() {
var root = document.querySelector('[data-wvc]'); if (!root || root.dataset.wvsInit) return;
var step = root.querySelector(`input[name='wvc-color']`); if (!step) return;
step = step.closest('fieldset'); root.dataset.wvsInit = '1';
var prev = document.createElement('div'); prev.className = 'wvs-prev is-loading';
prev.innerHTML = `<div class='wvs-stage'><canvas width='10' height='10' hidden role='img' aria-label='Voorbeeld van je kleurkeuze'></canvas><div class='wvs-sw' hidden><i></i><i></i></div></div>` +
`<div class='wvs-tools' hidden><button type='button' class='wvs-tg' data-t='light' aria-pressed='true'><span class='wvs-ic wvs-ic--bulb' aria-hidden='true'></span><span data-l>Licht aan</span></button>` +
`<label class='wvs-dim'><span>Dimmen</span><input type='range' min='10' max='100' step='5' value='100' aria-label='Lichtsterkte'></label>` +
`<button type='button' class='wvs-tg' data-t='night' aria-pressed='false'><span class='wvs-ic wvs-ic--moon' aria-hidden='true'></span><span data-l>Avond</span></button></div>` +
`<p class='wvs-prev__cap' data-wvs-cap aria-live='polite'></p>`;
step.querySelector('legend').insertAdjacentElement('afterend', prev);
var cv = prev.querySelector('canvas'), ctx = cv.getContext('2d'), sw = prev.querySelector('.wvs-sw'), cap = prev.querySelector('[data-wvs-cap]'), tools = prev.querySelector('.wvs-tools');
var box = root.querySelector('[data-wvc-custom]'), in1, in2;
if (box) {
in1 = box.querySelector(`input[name='wvc-custom-1']`); in2 = box.querySelector(`input[name='wvc-custom-2']`);
var dl = document.createElement('datalist'); dl.id = 'wvs-names';
dl.innerHTML = NAMES.filter(function (n) { return n[2]; }).map(function (n) { return `<option value='` + esc(n[0].charAt(0).toUpperCase() + n[0].slice(1) + ' (' + n[2] + ')') + `'>`; }).join('');
box.appendChild(dl);
[in1, in2].forEach(function (i) { if (i) { i.setAttribute('list', 'wvs-names'); i.placeholder = 'Naam, RAL- of NCS-code, bijv. Verkeerszwart, RAL 9017 of NCS S 2500-N'; } });
var chips = document.createElement('div'); chips.className = 'wvs-row';
chips.innerHTML = `<span>Of kies uit veelgekozen kleuren</span><div class='wvs-chips'>` + CHIPS.map(function (c) {
var nm = norm(c), item = NAMES.filter(function (n) { return n[0] === nm.split(' ').join(''); })[0] || NAMES.filter(function (n) { return nm.indexOf(n[0]) > -1; })[0];
var h = item ? item[1] : '#999', label = item && item[2] ? c + ' (' + item[2] + ')' : c;
return `<button type='button' class='wvs-chip' data-v='` + esc(label) + `'><i style='background:` + h + `'></i>` + esc(c) + '</button>';
}).join('') + '</div>';
var fin = document.createElement('div'); fin.className = 'wvs-row';
fin.innerHTML = `<span>Afwerking (kies er een)</span><div class='wvs-fin'>` + ['Mat', 'Glanzend'].map(function (f) {
return `<label><input type='radio' name='wvs-finish' value='' data-f='` + f + `'>` + f + '</label>';
}).join('') + `</div><p class='wvs-err' role='alert' hidden>Kies mat of glanzend.</p>`;
var pickRow = document.createElement('label'); pickRow.className = 'wvs-pick';
pickRow.innerHTML = `<span>Of kies een tint met de kleurkiezer</span><input type='color' value='#29292a' aria-label='Kies een tint'>`;
var note = document.createElement('p'); note.className = 'wvs-note';
note.textContent = 'De weergave is indicatief. Je kunt een naam, RAL- of NCS-code invullen of een omschrijving. We bevestigen je kleur altijd per mail.';
var anchor = box.querySelector('.wvc__hint');
[chips, fin, pickRow, note].forEach(function (el) { box.insertBefore(el, anchor); });
var tgt = in1;
[in1, in2].forEach(function (i) { if (i) i.addEventListener('focus', function () { tgt = i; }); });
chips.addEventListener('click', function (e) {
var b = e.target.closest('.wvs-chip'); if (!b) return;
tgt.value = b.dataset.v; tgt.dispatchEvent(new Event('input', { bubbles: true }));
});
finErr = fin.querySelector('.wvs-err'); finRow = fin;
fin.addEventListener('change', function (e) { state.finish = e.target.dataset.f || ''; finErr.hidden = true; draw(); });
pickRow.querySelector('input').addEventListener('input', function (e) {
tgt.value = 'Eigen tint ' + e.target.value.toUpperCase();
tgt.dispatchEvent(new Event('input', { bubbles: true }));
});
}
function nCustom() {
var col = root.querySelector(`input[name='wvc-color']:checked`);
var m = col && col.value ? (col.dataset.label || '').match(/^([0-9]) +kleur/i) : null;
return m ? parseInt(m[1], 10) : 0;
}
function leatherSel() {
var r = root.querySelector(`input[name='wvc-leder']:checked`), nm = r && r.value ? (r.dataset.label || '') : '';
return nm ? { name: nm, d: W.LEATHER ? W.LEATHER[nm] : null } : null;
}
function curLen() {
var f = document.querySelector('form.js-product-form-main'), i = f && f.querySelector(`input[name='id']`), V, t = '', m;
try { V = JSON.parse(root.dataset.variants || '{}'); } catch (e) { V = {}; }
if (i && V[i.value]) t = V[i.value].t || '';
m = t.match(/([0-9]{2,4}) *(cm|mm)/i) || handle.match(/([0-9]{3,4})(mm)/i) || handle.match(/([0-9]{2,3})(cm)/i);
if (!m) return 0;
var n = parseInt(m[1], 10);
return /cm/i.test(m[2]) ? n * 10 : n;
}
function tintFor(field) {
var col = root.querySelector(`input[name='wvc-color']:checked`);
if (nCustom() && box && !box.hidden) {
var inp = field === 2 ? in2 : in1, txt = inp ? inp.value.trim() : '';
return { hex: parse(txt), name: txt, custom: true };
}
if (!col) return { hex: null, name: '' };
var dot = col.closest('label').querySelector('.wvc__dot');
var c = dot ? getComputedStyle(dot).getPropertyValue('--c').trim() : '';
return { hex: c || null, name: col.dataset.label || 'RVS', metal: !col.dataset.mat };
}
/* afwerking voor de maskermotor */
function finFor(t) {
if (t.custom) return state.finish === 'Glanzend' ? 'glans' : (state.finish === 'Mat' ? 'mat' : 'satin');
if (/^rvs$/i.test(t.name || '')) return 'rvs';
if (REAL[t.name] && !(W.LEATHER && W.LEATHER[t.name])) return 'metal';
return t.metal ? 'rvs' : 'mat';
}
var D = null, M = null, busy = false, waiters = [], loaded = false;
function domUrls() {
var u = [];
document.querySelectorAll('.media-viewer__item img, product-media img, .product__media img').forEach(function (i) {
var s = i.currentSrc || i.src || '';
if (!s || /^data:|svg%3E/.test(s)) { var ss = i.getAttribute('srcset') || i.getAttribute('data-srcset') || ''; s = ss.split(',')[0].trim().split(' ')[0]; }
if (s) { s = s.replace(/([?&])width=[0-9]+/, '$1w0=1'); if (u.indexOf(s) < 0) u.push(s); }
});
return u;
}
function fail(msg) { state.imgFailed = true; state.error = msg || ''; finishLoad(); }
function finishLoad() { loaded = true; busy = false; prev.classList.remove('is-loading'); var q = waiters; waiters = []; q.forEach(function (f) { f(); }); }
function gotMask(m) {
M = m; state.engine = 'mask';
state.drawing = { w: m.w, h: m.h, spots: m.meta.s.length, parts: m.cnt, regions: m.dbg && m.dbg.regions };
finishLoad(); labels(); draw();
}
function ensure(cb) {
if (lampType) { loaded = true; state.engine = 'lamp'; prev.classList.remove('is-loading'); return cb(); }
if (loaded) return cb();
waiters.push(cb); if (busy) return; busy = true;
var spec = W.MSPEC && W.MSPEC[dKey];
var oldGo = function (urls) {
urls = urls.map(function (u) { return u.indexOf('//') === 0 ? 'https:' + u : u; });
state.urls = urls.length;
eng.pickBest(urls, function (best, res) {
state.scores = res;
if (!best) return fail('geen lijntekening gevonden');
state.src = urls.indexOf(best);
if (W.mask && spec) {
return W.mask.load(dKey, eng.sized(best, 1800), spec, function (m) {
if (m && m.meta.bb[2] > m.meta.bb[0]) return gotMask(m);
oldEngine(best);
});
}
oldEngine(best);
});
};
function oldEngine(best) {
eng.loadImg(eng.sized(best, 800), function (m) {
if (!m) return fail('tekening laden mislukt');
try {
D = eng.analyze(m, state.mode); state.engine = 'oud';
state.drawing = { w: D.w, h: D.h, comps: D.comps, under: D.under, crop: D.crop };
} catch (e) { return fail(String(e && e.message || e)); }
finishLoad(); draw();
});
}
var dm = window.WVS_DRAW || {}, du = dm[dKey];
var viaGallery = function () {
if (handle) {
fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (j) { oldGo(j.images && j.images.length ? j.images : domUrls()); }).catch(function () { oldGo(domUrls()); });
} else oldGo(domUrls());
};
if (du && W.mask && spec) {
state.src = 'site:' + dKey;
W.mask.load(dKey, du, spec, function (m) {
if (m && m.meta.bb[2] > m.meta.bb[0]) return gotMask(m);
eng.loadImg(du, function (img) {
if (img) { try { D = eng.analyze(img, state.mode, (W.SPOTS || {})[dKey]); state.engine = 'oud'; finishLoad(); draw(); return; } catch (e) { } }
viaGallery();
});
});
return;
}
viaGallery();
}
var fadeId = 0;
function paint(nv) {
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
cancelAnimationFrame(fadeId);
if (reduce || cv.hidden || cv.width !== nv.width || cv.height !== nv.height) {
cv.width = nv.width; cv.height = nv.height; ctx.clearRect(0, 0, cv.width, cv.height); ctx.drawImage(nv, 0, 0); return;
}
var old = document.createElement('canvas'); old.width = cv.width; old.height = cv.height; old.getContext('2d').drawImage(cv, 0, 0);
var t0 = performance.now();
(function f(now) {
var t = Math.min(1, (now - t0) / 220);
ctx.clearRect(0, 0, cv.width, cv.height); ctx.globalAlpha = 1 - t; ctx.drawImage(old, 0, 0);
ctx.globalAlpha = t; ctx.drawImage(nv, 0, 0); ctx.globalAlpha = 1;
if (t < 1) fadeId = requestAnimationFrame(f);
})(t0);
}
var m1 = state.mode === 'shell' ? 'plafondplaat en onderring' : 'buitenkant', m2 = state.mode === 'shell' ? 'schil' : 'onderzijde';
function names() {
if (M && M.meta.m1) return [M.meta.m1, M.meta.m2 || M.meta.m1];
return [m1, m2];
}
/* alle instellingen voor een render (ook gebruikt door 'Bekijk in jouw keuken' en de vergelijking) */
function opts(over) {
var n = nCustom(), t1 = tintFor(1), two = n === 2, t2 = two ? tintFor(2) : t1, lea = leatherSel();
var o = { c1: rgb(t1.hex || '#c9c6c1'), c2: rgb(t2.hex || '#c9c6c1'), f1: finFor(t1), f2: finFor(t2), lea: null, light: state.light, night: state.night, t1: t1, t2: t2, two: two, leaName: lea ? lea.name : '' };
if (lea && lea.d) { o.lea = lea.d; o.c2 = o.c1 = rgb((two ? t2 : t1).hex || '#c9c6c1'); o.f2 = o.f1 = finFor(two ? t2 : t1); }
if (over) for (var k in over) o[k] = over[k];
return o;
}
function renderMask(o) { return W.mask.render(M, o); }
function draw() {
var n = nCustom(), t1 = tintFor(1), two = n === 2, t2 = two ? tintFor(2) : t1, lea = leatherSel(), nn = names();
function nm(t) { return t.name ? '<strong>' + esc(t.name) + '</strong>' : '<em>nog niet gekozen</em>'; }
var label = two ? 'kleur 1 (' + esc(nn[0]) + ') ' + nm(t1) + ', kleur 2 (' + esc(nn[1]) + ') ' + nm(t2) : (t1.name ? nm(t1) : 'kies of typ een kleur');
var op = state.mode === 'shell' && !M ? 'plafondplaat en onderring' : 'overige delen', ot = two ? t2 : t1;
if (lea) label = lampType ? 'kleur ' + nm(ot) + ', lederen band <strong>' + esc(lea.name) + '</strong>' : 'leder <strong>' + esc(lea.name) + '</strong> (alleen de buitenmantel), ' + op + ' ' + nm(ot);
if (state.finish && box && !box.hidden) label += ', ' + esc(state.finish.toLowerCase());
var miss = (t1.name && !t1.hex) || (two && t2.name && !t2.hex);
cap.innerHTML = 'Voorbeeld: ' + label + (miss ? ' (deze tint tonen we hier niet exact, we bevestigen je kleur per mail)' : '');
ensure(function () {
prev.classList.toggle('is-night', state.night);
if (lampType) {
var met = !!REAL[t1.name], cc = rgb(t1.hex || (n ? '#c9c6c1' : '#0e0e10'));
W.lamp.draw(cv, lampType, { c: cc, met: met, len: curLen(), leather: lea && lea.d && lampType === 'moods' ? lea.d : null, L: state.light, night: state.night });
cv.hidden = false; sw.hidden = true; tools.hidden = false; return;
}
if (M) {
sw.hidden = true; tools.hidden = !M.meta.s.length;
paint(renderMask(opts())); cv.hidden = false; return;
}
var metal = !!t1.metal, c1 = rgb(t1.hex || '#c9c6c1'), c2 = rgb(t2.hex || '#c9c6c1');
if (lea && lea.d) {
var oc = rgb(ot.hex || '#c9c6c1'), sh = state.mode === 'shell';
c1 = oc; c2 = oc;
W.LS = { px: lea.d.px, tw: lea.d.tw, th: lea.d.th, pampas: lea.d.pampas, role: sh ? 1 : 0 };
} else W.LS = null;
if (!D) {
cv.hidden = true; sw.hidden = false;
var is = sw.querySelectorAll('i');
if (lea && lea.d) { is[0].style.background = lea.d.mean; is[1].style.background = ot.hex || '#c9c6c1'; return; }
is[0].style.background = t1.hex || '#c9c6c1'; is[1].style.background = two ? (t2.hex || '#c9c6c1') : (t1.hex || '#c9c6c1');
return;
}
sw.hidden = true;
var nv = eng.render(cv, D, c1, c2, state.finish === 'Glanzend' || metal, metal, metal ? .7 : .5);
paint(nv); cv.hidden = false;
});
}
var raf = 0;
function soon() { cancelAnimationFrame(raf); raf = requestAnimationFrame(draw); }
/* licht aan/uit, dimmen, avond */
var dim = tools.querySelector('input[type=range]'), lv = 1;
tools.addEventListener('click', function (e) {
var b = e.target.closest('button[data-t]'); if (!b) return;
var on = b.getAttribute('aria-pressed') !== 'true'; b.setAttribute('aria-pressed', String(on));
if (b.dataset.t === 'light') { state.light = on ? lv : 0; b.querySelector('[data-l]').textContent = on ? 'Licht aan' : 'Licht uit'; dim.disabled = !on; }
else { state.night = on; }
soon(); document.dispatchEvent(new CustomEvent('wvs:light'));
});
dim.addEventListener('input', function () { lv = dim.value / 100; if (state.light) state.light = lv; soon(); document.dispatchEvent(new CustomEvent('wvs:light')); });
root.querySelectorAll(`input[name='wvc-color'],input[name='wvc-leder']`).forEach(function (r) {
var hx = REAL[r.dataset.label], d = r.closest('label').querySelector('.wvc__dot');
if (hx && d) d.style.setProperty('--c', hx);
});
function labels() {
if (!box) return;
var n = nCustom(), l1 = box.querySelector('[data-wvc-field-label]'), f2 = box.querySelector(`[data-wvc-field='2'] span`), nn = names();
if (n === 2) { if (l1) l1.textContent = 'Kleur 1 (' + nn[0] + ')'; if (f2) f2.textContent = 'Kleur 2 (' + nn[1] + ')'; }
else if (l1) l1.textContent = 'Gewenste kleur (hele kap)';
}
root.addEventListener('change', function () { labels(); soon(); });
root.addEventListener('input', soon);
root.querySelectorAll('.wvc__hint').forEach(function (h) {
var t = h.textContent;
if (/sample|staal|staaltje/i.test(t)) h.textContent = /leer/i.test(t) ? 'Kleuren in beeld zijn indicatief en kunnen afwijken van de werkelijkheid.' : 'Geen metallic. Na je bestelling bevestigen we de kleur(en) per mail.';
});
/* 'Bekijk in jouw keuken' (alleen bij een getekend model of lamp) */
function kitchen() {
var src = (window.WVS_ASSET || {}).kitchen;
if (W.kitchen) return W.kitchen.open();
if (!src) return;
var s = document.createElement('script'); s.src = src; s.onload = function () { if (W.kitchen) W.kitchen.open(); }; document.head.appendChild(s);
}
var api = {
prev: prev, root: root, cv: cv, state: state, nCustom: nCustom, tintFor: tintFor, leatherSel: leatherSel, handle: handle, key: dKey,
get m1() { return names()[0]; }, get m2() { return names()[1]; }, in1: in1, in2: in2, soon: soon, finErr: function () { return finErr; },
mask: function () { return M; }, opts: opts, lampType: lampType, curLen: curLen,
/* render met eigen instellingen; geeft een canvas met transparante achtergrond */
renderFor: function (over) {
var o = opts(over);
if (lampType) { var c = document.createElement('canvas'); W.lamp.draw(c, lampType, { c: o.c1, met: o.f1 === 'metal', len: curLen(), leather: o.lea && lampType === 'moods' ? o.lea : null, L: o.light, night: o.night }); return c; }
if (M) return renderMask(o);
return cv;
},
kitchen: kitchen
};
W.api = api;
var kb = document.createElement('button'); kb.type = 'button'; kb.className = 'wvs-btn wvs-btn--kit'; kb.hidden = true;
kb.innerHTML = `<span class='wvs-ic wvs-ic--home' aria-hidden='true'></span>Bekijk in jouw keuken`;
kb.addEventListener('click', kitchen);
prev.appendChild(kb);
ensure(function () { kb.hidden = !(M || lampType); });
document.dispatchEvent(new Event('wvs:init'));
labels(); draw();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();